module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/olivia-carneval-74d5e098347c813127a1edd9552b466b.jpg";